/* eslint-disable func-style */
const hasOwnProp = Object.prototype.hasOwnProperty;

export function each<T = unknown, K = unknown>(obj: T, fn: (val: T[keyof T], key: keyof T, obj: T) => void, ctx?: K) {
  for (const key in obj) {
    if (hasOwnProp.call(obj, key)) {
      ctx ? fn.call(ctx, obj[key], key, obj) : fn(obj[key], key, obj);
    }
  }
}
